module.exports = __webpack_public_path__ + "static/media/Poliwhirl_gaussian2.f7edcc7c.png";